import { api } from "@/utils/api";
import { sanitizePathParam } from "@/utils/sanitize";

export default class KeplerRepository {
	async postGenerateKeplerAnimation(simulationInteractiveId: any, iterationId: any) {
		try {
			const sid = sanitizePathParam(simulationInteractiveId);
			const iid = sanitizePathParam(iterationId);
			const response = await api.post(
				`kepler/animation/simulationInteractive/${sid}/iteration/${iid}`,
			);
			return response.data;
		} catch (error) {
			console.error(error);
		}
	}

	async getKeplerAnimation(simulationInteractiveId: any) {
		try {
			const sid = sanitizePathParam(simulationInteractiveId);
			const response = await api.get(
				`kepler/animation/simulationInteractive/${sid}`,
			);
			return response.data;
		} catch (error) {
			console.error(error);
		}
	}

	async getKeplerHistorical(locationId: any) {
		try {
			const lid = sanitizePathParam(locationId);
			const response = await api.get(`kepler/sewer-analysis/location/${lid}`);
			return response.data;
		} catch (error) {
			if ((error as any)?.response?.status === 500) {
				return [];
			}
			throw error;
		}
	}

	async getSewerAnalysis(locationId: any) {
		try {
			const lid = sanitizePathParam(locationId);
			const response = await api.get(`kepler/sewer-analysis/location/${lid}`);
			return response.data;
		} catch (error) {
			if ((error as any)?.response?.status === 500) {
				return [];
			}
			throw error;
		}
	}

	async exportSewerAnalysisExcel(sewerAnalysisId: any) {
		try {
			const sid = sanitizePathParam(sewerAnalysisId);
			const response = await api.get(
				`kepler/sewer-analysis/${sid}/export/excel`,
				{
					responseType: 'blob',
				},
			);
			return response;
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async deleteSewerAnalysis(sewerAnalysisId: any) {
		try {
			const sid = sanitizePathParam(sewerAnalysisId);
			const response = await api.delete(`kepler/sewer-analysis/${sid}`);
			return response.data;
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async postGenerateKeplerHistorical(
		modelId: any,
		startTime: any,
		endTime: any,
		digitalTwinId: any,
		type: any,
		unitSystem: any,
		constraints: any,
		sensorPlacement: any,
		opportunities: any,
	) {
		const data = {
			modelId,
			startTime,
			endTime,
			digitalTwinId,
			type,
			unitSystem,
			constraints,
			sensorPlacement,
			opportunities,
		};
		try {
			const response = await api.post(`kepler/animation/historical`, data);
			return response.data;
		} catch (error) {
			console.error(error);
			throw error;
		}
	}
}
